import { PlpSelectedFacetOption, PresentationSortingOption } from "../model";

export interface PlpState_UrlDataTarget {
  selectedOptions: PlpSelectedFacetOption[];
  facetCache: FacetUrlCache;
  selectedSortingOption: PresentationSortingOption;
  page: number;
}

export type PlpState_UrlDataReadyToCache =
  | {
      [key: string]: string | string[] | [boolean, ...string[]] | number;
      page: number;
      _xf_: string[];
      sort: string;
    }
  | {
      [key: string]:
        | string
        | string[]
        | [boolean, ...string[]]
        | number
        | undefined;
      page: number;
      _xf_: string[];
      sort?: undefined;
    };

type FacetUrlCacheItem_Key_Name = string;
type FacetUrlCacheItem_DisplayName = string;
type FacetUrlCacheItem_Id = string;
type FacetUrlCacheItem_ResponseId = string;
type FacetUrlCacheItem = [
  FacetUrlCacheItem_DisplayName,
  FacetUrlCacheItem_Id,
  FacetUrlCacheItem_ResponseId
];
export type FacetUrlCache = {
  [key: FacetUrlCacheItem_Key_Name]: FacetUrlCacheItem;
};
export type FacetUrlCache_ObjectEntry = [
  FacetUrlCacheItem_Key_Name,
  FacetUrlCacheItem
];
export type UrlSerializedFacet = [
  FacetUrlCacheItem_Key_Name,
  FacetUrlCacheItem_DisplayName,
  FacetUrlCacheItem_Id,
  FacetUrlCacheItem_ResponseId
];
export const UrlSerializedFacet_OneItemLength = 4;

export interface PlpState_UrlCached {
  page?: number;
  startPage?: number;

  selectedSortingOption?: PresentationSortingOption;

  facets?: FacetUrlCache;

  selectedOptions?: PlpSelectedFacetOption[];
}

export type PlpSelectedFacetOptionQueryExtraData = [
  isMultiSelect: boolean,
  ...names: string[]
];

export const EXTRA_FACET_DISPLAY_NAMES_QUERY_KEY = "_xf_";
export const EXTRA_OPTIONS_CONFIGURATION_DATA_QUERY_KEY = "_xd";
export const EXTRA_OPTIONS_DATA_QUERY_KEY = "_xplp_";

export const decodeFacetNameFromExtraOptionsDataKey = (key: string) => {
  return key.substr(EXTRA_OPTIONS_DATA_QUERY_KEY.length);
};

export const decodeFacetNameFromExtraOptionsConfigurationDataKey = (
  key: string
) => {
  return key.substr(EXTRA_OPTIONS_CONFIGURATION_DATA_QUERY_KEY.length);
};
